module.exports = __webpack_public_path__ + "img/service_img15.2ee265d1.png";